// Einstellungen der Termin-Erinnerungen an Monteure (A-027 S3): an/aus, Vorabend 18 Uhr, Minuten vor dem Termin, Mail-Ersatz.
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X, Bell } from "lucide-react";
import { api } from "@/lib/api";

const MINUTEN = [[0, "keine"], [15, "15 Minuten"], [30, "30 Minuten"], [60, "1 Stunde"], [90, "1,5 Stunden"], [120, "2 Stunden"]];

export default function ErinnerungenDialog({ onClose }) {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/module-termine/admin/settings").then((r) => setS(r.data)).catch(() => { toast.error("Einstellungen konnten nicht geladen werden"); onClose(); }); }, []); // eslint-disable-line
  const speichern = async () => {
    setSaving(true);
    try {
      await api.put("/module-termine/admin/settings", {
        erinnerung_aktiv: s.erinnerung_aktiv, erinnerung_vorabend: s.erinnerung_vorabend,
        erinnerung_minuten: Number(s.erinnerung_minuten), erinnerung_mail_vorabend: s.erinnerung_mail_vorabend,
      });
      toast.success("Erinnerungen gespeichert");
      onClose();
    } catch (err) { toast.error(err?.response?.data?.detail || "Speichern nicht möglich (nur Administrator)"); }
    finally { setSaving(false); }
  };
  const haken = (k, text, hinweis) => (
    <label className="flex items-start gap-3 py-2 cursor-pointer">
      <input type="checkbox" checked={!!s[k]} onChange={(e) => setS((x) => ({ ...x, [k]: e.target.checked }))} className="mt-1 w-5 h-5" data-testid={`erinnerung-${k}`} />
      <span><span className="block text-sm font-medium">{text}</span>{hinweis && <span className="block text-xs text-muted-foreground">{hinweis}</span>}</span>
    </label>
  );
  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" data-testid="erinnerungen-dialog">
      <div className="bg-background rounded-lg shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between p-4 border-b">
          <h2 className="text-lg font-semibold flex items-center gap-2"><Bell className="w-5 h-5" /> Erinnerungen an Monteure</h2>
          <button onClick={onClose} className="p-1 hover:bg-muted rounded-sm" aria-label="Schließen"><X className="w-5 h-5" /></button>
        </div>
        {s && (
          <div className="p-4 space-y-1">
            {haken("erinnerung_aktiv", "Erinnerungen einschalten", "Als Nachricht aufs Handy (Benachrichtigungen müssen am Handy erlaubt sein).")}
            {haken("erinnerung_vorabend", "Am Vorabend um 18 Uhr", "„Morgen: 3 Termine, erster 7:30 bei …“")}
            <label className="block py-2">
              <span className="block text-sm font-medium mb-1">Vor jedem Termin erinnern</span>
              <select value={s.erinnerung_minuten} onChange={(e) => setS((x) => ({ ...x, erinnerung_minuten: Number(e.target.value) }))} className="w-full border rounded-sm p-2 text-sm" data-testid="erinnerung-minuten">
                {MINUTEN.map(([m, t]) => <option key={m} value={m}>{t}{m ? " vorher" : ""}</option>)}
                {!MINUTEN.some(([m]) => m === Number(s.erinnerung_minuten)) && <option value={s.erinnerung_minuten}>{s.erinnerung_minuten} Minuten vorher</option>}
              </select>
            </label>
            {haken("erinnerung_mail_vorabend", "Wer kein Handy-Benachrichtigung hat: Mail am Vorabend", "Standard: aus. Die Mail geht an die E-Mail-Adresse des Benutzers.")}
          </div>
        )}
        <div className="p-4 border-t flex justify-end gap-2">
          <button onClick={onClose} className="px-4 py-2 text-sm border rounded-sm hover:bg-muted">Abbrechen</button>
          <button onClick={speichern} disabled={!s || saving} className="px-4 py-2 text-sm bg-primary text-primary-foreground rounded-sm hover:bg-primary/90 disabled:opacity-50" data-testid="erinnerung-speichern">{saving ? "Speichere…" : "Speichern"}</button>
        </div>
      </div>
    </div>
  );
}
